// ── wiki 创始人提及（联系方式面板的补充信息块）───────────────────────
// EarlyBirdTab.jsx（卡片）和 EarlyBirdWikiModal.jsx（wiki 抽屉）的"求联系方式"
// 结果都要展示这个块，单独抽出来避免两处各写一份、又出现之前"改了卡片忘了改
// wiki 面板"那种漂移问题。放单独文件而不是从其中一个组件互相 import，是因为
// EarlyBirdTab.jsx 本身就 import 了 EarlyBirdWikiModal——两者互相引用会有循环
// 依赖风险。
//
// wiki 创始人段落是 AI 从网络搜索综合出来的（带 [n] 引用编号，跟 wiki 面板里
// 展示的是同一份文本），不是本人自愿公开、以"方便联系"为目的的渠道——只是
// "网上有提到这个人"。跟 email/twitter/team 这些经过验证的字段要明确区分开，
// 避免被当成可以直接联系的方式误用。
const C = { border: '#e4e4e7', muted: '#71717a' };
const truncate = (s, n) => (s.length > n ? `${s.slice(0, n).trim()}…` : s);

export function WikiFoundersMention({ text, lang }) {
  return (
    <div style={{ marginTop: 6, paddingTop: 6, borderTop: `1px dashed ${C.border}` }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 3 }}>
        <span style={{
          fontSize: 9, padding: '1px 7px', borderRadius: 999,
          background: '#f4f4f5', color: '#71717a',
        }}>{lang === 'en' ? 'AI · unverified' : 'AI 生成 · 未验证'}</span>
        <span style={{ fontSize: 10, color: C.muted }}>
          {lang === 'en' ? 'Wiki mentions (not a self-disclosed contact channel)' : 'wiki 中提及（非本人自愿公开的联系渠道）'}
        </span>
      </div>
      <div style={{ fontStyle: 'italic', color: '#71717a' }}>{truncate(text, 200)}</div>
    </div>
  );
}
